<button class="field-action btn" type="button" [class.action-disabled]="disabled" (click)="emitAction()">
  <i class="cc-icon sm-mr-1 {{ fieldConfig[type].icon }}" aria-hidden="true"></i>
  <span class="control-label">{{ fieldConfig[type].label }}</span>
</button>
